// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



// WEBPACK FOOTER //
// webpack://idx/node_modules/core-js-pure/internals/enum-bug-keys.js